module.exports = __webpack_public_path__ + "img/show2_pc.80962e83.svg";